import { useQuery } from '@tanstack/react-query';

import { get } from '../api/ventura/reportTemplates';
import { camelCaseKeys } from '../util/object';
import { useConfig } from './useConfig';

function useReportTemplate(reportTemplateId: number) {
  const { apiHost } = useConfig();

  return useQuery({
    queryKey: ['reportTemplate', reportTemplateId],
    queryFn: () => get(apiHost, reportTemplateId),
    select: camelCaseKeys,
  });
}

export default useReportTemplate;
